import { ReactComponent as BlueprintText } from '@backrs_ui/grow-ui/public/images/light-blueprint-text-transparent-background.svg';

import { Box, Typography, SxProps, Theme } from '@mui/material';

type SchoolLevelQuestionTextProps = Readonly<{
  title: string;
  question_body: string;
}>;

export function SchoolLevelQuestionText({ title, question_body }: SchoolLevelQuestionTextProps) {
  return (
    <Box sx={relativeSx}>
      <Box sx={blueprintHeaderSx}>
        <Box sx={imageContainerSx}>
          <BlueprintText />
        </Box>
      </Box>
      <Box sx={contentSx}>
        <Typography
          color={(theme: Theme) => theme.backrs.colors['Colors/Base/Black']}
          variant="text-xl-semibold"
          sx={titleSx}
        >
          {title}
        </Typography>
        <Typography
          variant="text-md-regular"
          color={(theme: Theme) => theme.backrs.colors['Colors/Base/Black']}
          sx={questionSx}
        >
          {question_body}
        </Typography>
      </Box>
    </Box>
  );
}

const relativeSx: SxProps<Theme> = {
  position: 'relative',
  width: '100%',
};

const imageContainerSx: SxProps<Theme> = ({ backrs }) => ({
  padding: backrs.spacing['spacing-3xl'],
});

const blueprintHeaderSx: SxProps<Theme> = ({ backrs }) => ({
  position: 'relative',
  top: 0,
  left: 0,
  right: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 0,
  backgroundImage: `linear-gradient(${backrs.colors['Brand/500']}33 1px, transparent 1px),
    linear-gradient(90deg, ${backrs.colors['Brand/500']}33 1px, transparent 1px)`,
  backgroundSize: '15px 15px',
  backgroundColor: backrs.colors['Colors/Base/White'],
  borderRadius: `${backrs.radius['radius-2xl']} ${backrs.radius['radius-2xl']} 0 0`,
  borderBottom: `1px solid ${backrs.colors['Colors/Base/Black']}`,
  width: '100%',
});

const contentSx: SxProps<Theme> = ({ backrs }) => ({
  zIndex: 1,
  display: 'flex',
  flexDirection: 'column',
  gap: backrs.spacing['spacing-xs'],
  px: backrs.spacing['spacing-3xl'],
  pt: backrs.spacing['spacing-3xl'],
});

const titleSx: SxProps<Theme> = {
  fontWeight: 600,
  fontSize: '1.25rem',
  lineHeight: 1.4,
};

const questionSx: SxProps<Theme> = {
  fontSize: '1rem',
  lineHeight: 1.5,
};
